module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002.5b9261d.webp";